module.exports = __webpack_public_path__ + "static/media/purewater.72a6ff12.png";